// extracted by mini-css-extract-plugin
module.exports = {"feed__filters":"styles_feed__filters__wBM4u"};